module.exports = __webpack_public_path__ + "static/scale-model-of-utah-lake-state-park-in-provo-utah-e929dc72a5969a56f20c36dbc3ee044f.png";